// imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HasPermission } from 'Core/security';

// views
import MainView from 'Modules/reports/views/main';

const RouterReports = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <Routes>
            {
                HasPermission(user, "nr", [21]) &&
                <Fragment>
                    <Route path='/' element={<Navigate to="/app/reports/main" />}></Route>
                    <Route path='viewReport/:id' element={<MainView />} />
                    <Route path='main' element={<MainView />} />
                </Fragment>
            }
            <Route path="*" element={<Navigate to="/app/error" />} />
        </Routes>
    );
};

export default RouterReports
